import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import loadPerformanceWidgetFrequencies from "@tecumseh/Handlers/PerformanceFreqData";
import {
    Fluide,
    getWidgetInfo,
    LocalizationEnum,
    PerformanceWidgetInfo,
    WidgetInfoParameter,
} from "@tecumseh/Services/PerformanceWidgetService";
import { CustomApiHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

type WidgetInfoHandlerType = CustomApiHandler<WidgetInfoParameter, PerformanceWidgetInfo>;

export const DispatchBeginWidgetInfo: WidgetInfoHandlerType = props => {
    props.dispatch({
        type: "Custom/WidgetInfo/BeginLoadWidgetInfo",
    });
};

export const RequestWidgetInfoData: WidgetInfoHandlerType = async props => {
    props.apiResult = await getWidgetInfo(props.parameter);

    if (!props.apiResult || (props.apiResult as any).error) {
        // TODO: Set Error in Reducer
        return false;
    }
};

export const WidgetInfoCompleted: WidgetInfoHandlerType = props => {
    props.dispatch({
        type: "Custom/WidgetInfo/CompleteLoadWidgetInfo",
        widgetInfo: props.apiResult,
    });
};

export const LoadWidgetFreqs: WidgetInfoHandlerType = props => {
    const productType = props.apiResult.productType;
    const fluides = props.apiResult.fluides;
    // const currentFluide =
    //     fluides && fluides.length === 1
    //         ? fluides[0]
    //         : fluides && fluides.length > 1
    //         ? ({ refrigerant: props.apiResult.textes[LocalizationEnum.REFRIGERANT_CHOOSE] } as Fluide)
    //         : undefined;
    const currentFluide = fluides && fluides.length > 0 ? fluides[0] : undefined;
    const fluide = currentFluide && currentFluide.refrigerant ? currentFluide.refrigerant : "";
    const applicationId = props.apiResult.applicationID;
    const mid = currentFluide?.def_Cond?.toLowerCase() === "mid";

    props.dispatch({
        type: "Custom/WidgetInfo/SetSelectedFluid",
        selectedFluid: fluide,
    });

    if (fluide === props.apiResult.textes[LocalizationEnum.REFRIGERANT_CHOOSE]) {
        props.dispatch({
            type: "Custom/WidgetInfo/SetSelectedFreq",
            selectedFreq: props.apiResult.textes[LocalizationEnum.REFRIGERANT_FIRST],
        });
    }

    if (fluides.length > 0) {
        props.dispatch(
            loadPerformanceWidgetFrequencies({
                type: productType,
                model: props.parameter.model,
                lang: props.parameter.lang,
                fluide,
                applicationId,
                mid,
            }),
        );
    }
};

export const chain = [DispatchBeginWidgetInfo, RequestWidgetInfoData, WidgetInfoCompleted, LoadWidgetFreqs];

const loadPerformanceWidgetInfo = createHandlerChainRunner(chain, "LoadPerformanceWidgetInfo");

export default loadPerformanceWidgetInfo;
